import { ReactNode } from 'react';
import Button from 'v3/components/Button';
import Footer from 'v3/components/Footer';
import Header from 'v3/components/Header';

import * as S from './styles';

type LayoutProps = {
  children: ReactNode;
  hasHeaderLinks?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
};

const Layout = ({
  children,
  hasHeaderLinks = true,
  hideHeader = false,
  hideFooter = false,
}: LayoutProps) => {
  const headerLinks = [
    {
      item: (
        <S.HeaderLink href="https://savings.club/what-is-savings-club">
          What is savings.club
        </S.HeaderLink>
      ),
    },
    {
      item: (
        <S.HeaderLink href="https://savings.club/how-it-works">
          How it works?
        </S.HeaderLink>
      ),
    },
    {
      item: (
        <S.HeaderLink href="https://savings.club/calculator">
          Calculator
        </S.HeaderLink>
      ),
    },
    {
      item: (
        <S.HeaderLink href="https://support.savings.club/en">
          Support
        </S.HeaderLink>
      ),
    },
    {
      item: (
        <Button size="medium" as="a" href="https://contractflow.savings.club/deals/">
          Join now
        </Button>
      ),
    },
  ];

  return (
    <S.Container>
      {!hideHeader && <Header itemList={hasHeaderLinks ? headerLinks : []} />}
      <S.Main>{children}</S.Main>
      {!hideFooter && (
        <Footer
          youtube="https://www.youtube.com/channel/UCj4qT95998XTRyX-bhYeySg"
          facebook="https://www.facebook.com/thesavingsclub"
          instagram="https://www.instagram.com/savings.club/"
          linkedin="https://www.linkedin.com/company/savings-club"
        />
      )}
    </S.Container>
  );
};

export default Layout;
